module.exports = __webpack_public_path__ + "static/media/DEX.407b7942.png";